import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import Filtre from 'EurestoComponents/Filtre'
import Constants from 'EurestoFonction/Constants'
import moment from 'moment'
import React from 'react'
import SearchAllianceReseaux from '../../Module/AllianceReseaux//Component/Search'
import SearchApi from '../../Module/Api//Component/Search'
import DonneesAnnexesMenu from '../../Module/Configuration/Component/Menu'
import SearchCrm from '../../Module/CRM/Component/Search'
import SearchFidelite from '../../Module/Fidelite/Component/Search'
import SearchDbm from '../../Module/Gestion/Component/Search/Dbm'
import SearchProduit from '../../Module/Gestion/Component/Search/Produit'
import SearchResaHotel from '../../Module/Hotel/Component/Search'
import SearchMedia from '../../Module/Media/Component/Search'
import SearchResa from '../../Module/Restaurant/Component/Search'
import SearchCas from '../../Module/SDD/Component/Cas/Search'
import SearchSMS from '../../Module/SDD/Component/Message/Search'
import SearchSdd from '../../Module/SDD/Component/Search'
import SearchDocument from '../../Module/Stock/Component/Search'
const project = require('EurestoConfig/project.config')


moment.locale('fr')

export default [
  {
    label: 'CRM',
    icon: ' ei-module_crm',
    autorisation: user => User.User.get().type === 1 || User.User.get().profil_id !== 6 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1350)),
    menu: [
      {
        'label': 'Ajout',
        'link': '/crm/ajout',
        'icon': ' ei-commun_ajouter',
      },
      {
        'label': 'Recherche',
        'link': '/crm',
        'icon': ' ei-commun_rechercher',
        component: _ => <SearchCrm defaultSearch={{ '?actif': 1 }} />,
      },
      {
        'label': 'Filtre',
        'link': '/crm/filtre',
        'icon': ' ei-commun_filtrer',
        component: _ => <Filtre donnee={Constants.donnee.client} module={Constants.module.CRM}
          search={'client_filtre_main'} />,
      },
      {
        'label': 'Outils',
        'link': '/crm/outils',
        'icon': ' ei-module_crm_4'
      },
    ]
  },
  {
    label: 'Produit',
    icon: ' ei-module_gestion',
    autorisation: () => User.User.get().type === 1 && User.TypeAccess.get(Constants.access.ETABLISSEMENT)
      && EurestoOption(Constants.options[Constants.methods.GESTION].id),
    menu: [
      {
        'label': 'Ajout',
        'link': '/gestion/ajout',
        'icon': ' ei-commun_ajouter',
      },
      {
        'label': 'Mercuriale',
        'link': '/gestion/mercuriale',
        'icon': ' ei-gestion_famille',
        component: _ => <SearchProduit name={'produit_mercuriale'}
          defaultSearch={{ 'type_produit_id': 3 }} />,
      },
      {
        'label': 'FT Base',
        'link': '/gestion/ft-base',
        'icon': ' ei-gestion_produit',
        component: _ => <SearchProduit name={'produit_base'}
          defaultSearch={{ 'type_produit_id': 5 }} />,
      },
      {
        'label': 'Produit & FT',
        'link': '/gestion/vente-ft',
        'icon': ' ei-gestion_fiche_technique',
        component: _ => <SearchProduit name={'produit_vente'}
          defaultSearch={{ 'type_produit_id': [1, 2] }} />,
      },
      {
        'label': 'Vin',
        'link': '/gestion/vin',
        'icon': ' ei-gestion_vin',
        autorisation: () => User.User.get().type === 1 && EurestoOption(Constants.options[Constants.methods.GESTION].VIN.id),
        component: _ => <SearchProduit name={'produit_vin'}
          defaultSearch={{ 'type_produit_id': 4 }} />,
      },
      {
        'label': 'Dbm',
        'link': '/gestion/dbm',
        'icon': ' ei-commun_rechercher',
        autorisation: () => {
          return User.User.get().type === 1 && EurestoOption(Constants.options[Constants.methods.GESTION].DBM.id)
        },
        component: _ => <SearchDbm
          defaultSearch={{ '%date_preparation': '>', 'date_preparation': moment().format('YYYY-MM-DD') }} />,
      },
    ]
  },
  {
    label: 'Restaurant',
    icon: ' ei-module_reservation',
    autorisation: () => {
      return User.TypeAccess.get(Constants.access.ETABLISSEMENT)
        && EurestoOption(Constants.options[Constants.methods.RESTAURANT].id)
    },
    menu: [
      {
        'label': 'Réservation',
        'link': '/restaurant/reservation',
        'icon': ' ei-commun_rechercher',
        component: _ => <SearchResa name={'reservation'} type={'reservation'} defaultSearch={{
          '>niveau': 0,
          'niveau': [4, 5],
          'niveau_non': true,
          'date_reservation': moment().format('YYYY-MM-DD')
        }} />,
      },
      {
        'label': 'Demande',
        'link': '/restaurant/demande',
        'icon': ' ei-commun_rechercher',
        autorisation: user => User.User.get().type === 1 || User.User.get().profil_id !== 6 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1350)),
        component: _ => <SearchResa name={'demande'} type={'demande'} defaultSearch={{
          'niveau': [0],
          '%date_reservation': '>',
          'date_reservation': moment().format('YYYY-MM-DD')
        }} />,
      },
    ]
  },
  {
    label: 'Hotel',
    icon: ' ei-module_reservation',
    autorisation: () => {
      return User.User.get().type === 1 && User.TypeAccess.get(Constants.access.ETABLISSEMENT)
        && EurestoOption(Constants.options[Constants.methods.HOTEL].id)
    },
    menu: [
      {
        'label': 'Réservation',
        'link': '/hotel/reservation',
        'icon': ' ei-commun_rechercher',
        component: _ => <SearchResaHotel type={'reservation'} defaultSearch={{
          '>=date_debut': moment().format('YYYY-MM-DD')
        }} />,
      },
    ]
  },
  /*{
    label: 'Pédagogie',
    icon: ' ei-module_pedagogie',
    autorisation: () => {
      return User.TypeAccess.get(Constants.access.ETABLISSEMENT)
        && EurestoOption(Constants.options[Constants.methods.PEDAGOGIQUE].id)
    },
    menu: [
      {
        'label': 'Exercice',
        'link': '/pedagogie/exercice',
        'icon': ' ei-pedagogie_exercice',
      },
      {
        'label': 'Exercice',
        'link': '/pedagogie/exercice',
        'icon': ' ei-commun_rechercher',
        component: _ => <SearchExercice/>,
      },
      {
        'label': 'Document',
        'link': '/pedagogie/document',
        'icon': ' ei-commun_rechercher',
      }
    ]
  }*/, {
    label: 'Media',
    icon: ' ei-module_fidelite',
    autorisation: user => User.User.get().type === 1 || User.User.get().profil_id === 4 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1352)),
    menu: [
      {
        'label': 'Recherche',
        'link': '/media',
        'icon': ' ei-commun_rechercher',
        component: _ => <SearchMedia />,
      },
    ]
  }, {
    label: 'Alliance Réseaux',
    icon: ' ei-module_fidelite',
    autorisation: () => {
      return User.TypeAccess.get(Constants.access.ETABLISSEMENT)
        && EurestoOption(Constants.options[Constants.methods.INTERFACE].ALLIANCE_RESEAUX.id)
    },
    menu: [
      {
        'label': 'Recherche',
        'link': '/alliance_reseaux',
        'icon': ' ei-commun_rechercher',
        component: _ => <SearchAllianceReseaux />,
      },
    ]
  },
  {
    label: 'Fidélité',
    icon: ' ei-module_fidelite',
    autorisation: () => {
      return User.User.get().type === 1 && User.TypeAccess.get(Constants.access.ETABLISSEMENT)
        && EurestoOption(Constants.options[Constants.methods.FIDELITE].id)
    },
    menu: [
      {
        'label': 'Recherche',
        'link': '/fidelite',
        'icon': ' ei-commun_rechercher',
        component: _ => <SearchFidelite defaultSearch={{ '?points': true, 'actif': true }} />,
      },
    ]
  },
  {
    label: 'Suivi Dossiers',
    icon: ' ei-module_sdd',
    autorisation: user => User.User.get().type === 1 || User.User.get().profil_id === 4 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1352)),
    notif: Data.list(Constants.module.MESSAGERIE, Constants.donnee.message).length,
    menu: [
      {
        'label': 'Recherche',
        'link': '/sdd/dossier',
        'icon': ' ei-commun_rechercher',
        component: _ => <SearchSdd defaultSearch={{
          '[[group_by]]': !User.User.get().regroupement_tache && 'sdd_action.id' || 'sdd_action.contact_id,sdd_action.classeur_id,sdd_action.dossier_id',
          '?actif': 1, '?tous': 1, 'type_action_id': [1, 2, 3], 'type_action_id_non': true
        }} />,
      },
      {
        label: 'Email/Sms',
        link: '/sdd/message',
        icon: ' ei-commun_commentaire',
        component: _ => <SearchSMS defaultSearch={{ 'status': [1, null] }} group_by={['source', 'maxId']} />,
      },
      {
        label: 'Bug',
        link: '/sdd/bug',
        icon: ' ei-commun_redmine',
        autorisation: () => {
          return User.TypeAccess.get(Constants.access.EURESTO)
        },
        component: _ => <SearchCas searchName={'bug_'} defaultSearch={{
          '[[group_by]]': 'sdd_action.contact_id,sdd_action.classeur_id,sdd_action.dossier_id',
          '?actif': 1, '?tous': 1, 'type_action_id': [1, 2, 3], 'type_action_id_non': true, 'classeur_id': 50
        }} />,
      },
      {
        label: 'Développement',
        link: '/sdd/developpement',
        icon: ' ei-sdd_dossier',
        autorisation: () => {
          return User.TypeAccess.get(Constants.access.EURESTO)
        },
        component: _ => <SearchCas searchName={'developpement_'} defaultSearch={{
          '[[group_by]]': 'sdd_action.contact_id,sdd_action.classeur_id,sdd_action.dossier_id',
          '?actif': 1, '?tous': 1, 'type_action_id': [1, 2, 3], 'type_action_id_non': true, 'classeur_id': 49
        }} />,
      },
    ]
  },
  {
    label: 'Suivi Stock',
    icon: ' ei-module_sdd',
    autorisation: user => User.User.get().id === 2 && EurestoOption(Constants.options[Constants.methods.GESTION].id),
    notif: Data.list(Constants.module.MESSAGERIE, Constants.donnee.message).length,
    menu: [
      {
        'label': 'Ajout',
        'link': '/stock/document',
        'icon': ' ei-commun_ajouter',
      },
      {
        'label': 'Recherche',
        'link': '/stock/documents',
        'icon': ' ei-commun_rechercher',
        component: _ => <SearchDocument searchName={'document_'} />,
      },
    ]
  },
  {
    label: 'Configurations',
    icon: ' ei-module_configuration',
    autorisation: user => User.User.get().type === 1 || User.User.get().profil_id !== 6 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1350)),
    menu: [
      {
        label: 'CRM',
        link: '/configuration/crm',
        icon: ' ei-module_crm',
        autorisation: user => User.User.get().type === 1 || User.User.get().profil_id === 4 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1352)),
        component: _ => <DonneesAnnexesMenu path={'crm'} />,
      },
      {
        label: 'Gestion',
        link: '/configuration/gestion',
        icon: ' ei-module_gestion',
        autorisation: () => User.User.get().type === 1 && User.TypeAccess.get(Constants.access.ETABLISSEMENT)
          && EurestoOption(Constants.options[Constants.methods.GESTION].id),
        component: _ => <DonneesAnnexesMenu path={'gestion'} />,
      },
      {
        label: 'Restaurant',
        link: '/configuration/restaurant',
        icon: ' ei-module_reservation',
        autorisation: () => (User.User.get().type === 1 || User.User.get().profil_id !== 6 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1350))) && User.TypeAccess.get(Constants.access.ETABLISSEMENT)
          && EurestoOption(Constants.options[Constants.methods.RESTAURANT].id),
        component: _ => <DonneesAnnexesMenu path={'restaurant'} />,
      },
      {
        label: 'Hotel',
        link: '/configuration/hotel',
        icon: ' ei-module_reservation',
        autorisation: () => User.User.get().type === 1 && User.TypeAccess.get(Constants.access.ETABLISSEMENT)
          && EurestoOption(Constants.options[Constants.methods.HOTEL].id),
        component: _ => <DonneesAnnexesMenu path={'hotel'} />,
      },
      {
        label: 'Suivi de dossier',
        link: '/configuration/sdd',
        icon: ' ei-module_sdd',
        autorisation: () => User.User.get().type === 1,
        component: _ => <DonneesAnnexesMenu path={'sdd'} />,
      },
      {
        label: 'Pédagogie',
        link: '/configuration/pedagogie',
        icon: ' ei-module_pedagogie',
        autorisation: user => User.User.get().type === 1 && User.TypeAccess.get(Constants.access.ETABLISSEMENT)
          && EurestoOption(Constants.options[Constants.methods.PEDAGOGIQUE].id),
        component: _ => <DonneesAnnexesMenu path={'pedagogie'} />,
      },
      {
        label: 'Facturation',
        link: '/configuration/facturation',
        icon: ' ei-module_configuration',
        autorisation: user => User.User.get().type === 1 && User.TypeAccess.get(Constants.access.ETABLISSEMENT)
          && EurestoOption(Constants.options[Constants.methods.FACTURATION].id),
        component: _ => <DonneesAnnexesMenu path={'facturation'} />,
      },
      {
        label: 'Etablissement',
        link: '/configuration/etablissement',
        icon: ' ei-module_configuration',
        autorisation: user => User.User.get().id === 2,
        component: _ => <DonneesAnnexesMenu path={'etablissement'} />,
      },
      {
        label: 'Interface',
        link: '/configuration/interface',
        icon: ' ei-module_interface',
        autorisation: () => User.User.get().type === Constants.access.EURESTO && User.TypeAccess.get(Constants.access.ETABLISSEMENT)
          && (Data.list(Constants.module.COMMUN, Constants.donnee.option) || []).findIndex(option => option.id > 3000 && option.id < 3999 && EurestoOption(option.id)) !== -1,
        component: _ => <DonneesAnnexesMenu path={'interface'} />,
      },
    ]
  }, {
    label: 'API',
    icon: ' ei-sdd_classeur',
    autorisation: user => (User.User.get().id === 2 || User.User.get().id === 8),
    menu: [
      {
        'label': 'Recherche',
        'link': '/requete-api',
        'icon': ' ei-commun_rechercher',
        component: _ => <SearchApi />,
      },
    ]
  },
  // {
  //   label: 'Documentation',
  //   icon: ' ei-sdd_classeur',
  //   autorisation: () => {
  //     return (User.User.get().id === 2 || User.User.get().id === 59202 || User.User.get().id === 60689) && User.TypeAccess.get(Constants.access.EURESTO)
  //   },
  //   menu: [
  //     {
  //       label: 'API',
  //       link: '/documentation',
  //       icon: 'ei-module_documentation',
  //     },
  //   ]
  // },
]







// WEBPACK FOOTER //
// ./app/App/Static/Menu/Menu.js